<template>
    <div class="app-het">
      <div v-if="debug_show_page_name==true" style="color:green;">page_0040_certificate_information_detail_bulk_edit</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="証書情報(一括編集）" >

          </title-and-slot>

          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4">
              <button class="btn btn-primary" style="min-width:100px;width: 25%;float: left;margin-left: 10px;" @click="backToList" >＜　戻る</button>
            </div>
            <div class="col-xs-8">
            </div>
          </div>
          <div class="row" style="margin-bottom:10px;">
            状態：
            <select
            :disabled="readOnly"
            :value="Status"
            @change="Status = $event.target.value"
            style=" border: solid #337ab7 1px;width: 90px; padding-left:4px;margin: 2px;border-radius: 5px;background-color: #e2ecf5;font-size: 12px;" >
             <option v-for="option in StatusOptions" :selected="option==Status" :key="option" :value="option">{{option}}</option>
            </select>
          </div>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
              <!-- Coll A<br> -->
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-8" style="">
              <div class="row">
                <div class="col-xs-6" style="">
                  <!-- Coll B <br> -->
                  <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f" :read="readOnly"   :val="values[f.id]"></field-box>
                </div>
                <div class="col-xs-6" style="">
                  <!-- Coll C<br> -->
                  <field-box   v-for="f in formFields.col3"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12" style="">
                  <field-box   v-for="f in formFields.col2b"  v-bind:key="f.id" v-bind:data="f" :read="readOnly"   :val="values[f.id]"></field-box>
                </div>
              </div> 
            </div>
          </div>
          <div>
              <button v-show="showApplyButton == true" class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;" @click="onConfirmExecuteProcess" >申請</button>
              <button v-if="read_only == false" :disabled="false" class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 10px;background: #337ab7;" @click="onLocalSaveBulkCerInfeded" >下書保存</button>
          </div>
        </div>
        <device-embedded-information-confirmation-modal tag="showBulkImportConfimationModal" />
        <confirmation-modal tag="confirmBulkCertificateInformationAddCheck" @done="onBulkCertificateInformationAddCheckConfirm" />
        <application-confirmation-modal tag="bulkCertificateApplicationConfimationModal" />
        <file-modal tag="showFileModal" />
     </div>
</template>


<script>
import deviceembeddedinformationaddcheck from '@/components/modals/device-embedded-information-add_check';
import subTable from '@/components/sub_pages/device-embedded-detail';
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_certificate_information';
import bulkImportConfirmationModal from "@/components/modals/device-embedded-information-confirmation-modal";
import applicationConfirmationModal from '@/components/modals/application-confirmation-modal';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:device_embedded_information');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
import fileModal from "@/components/modals/file-modal";
import constants from "@/rules/constants";
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
    'sub-table': subTable,
    "device-embedded-information-confirmation-modal" :bulkImportConfirmationModal,
    'device-embedded-information-bach-edit-modal' : deviceembeddedinformationaddcheck,
    'file-modal':fileModal,
    'application-confirmation-modal':applicationConfirmationModal
  },
  data() {
    return {
      api_name:"certificate_information",
      page_acl: acl.generic,
      show_apply_button:false,
      approval_id:null
    };
  },
  computed: {
    showApplyButton:{
      get(){
        return this.show_apply_button;
      },
      set(v){
        this.show_apply_button = v;
      }
    },
    Status:{
      get(){
        if(this.local_status === false){
          return this.$store.state[this.stateCurrentRow]["status"] || "";
        }else{
          return this.local_status;
        }
      },
      set(v){
        this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
      }
    },
    StatusOptions(){
      return fields.status.options;
    },
    // showMyButton (){
    //   return (this.isAdmin ) && this.loadBy == 'ref_id';
    // },
    aprovalId:{
      get(){
        return this.aproval_id;
      },
      set(v){
        this.aproval_id = v;
      }
    },
    approvalStatus(){
      return this.$store.state[this.stateCurrentEditing]["approval_status"] || this.$store.state[this.stateCurrentRow]["approval_status"]
    },
    deviceControlNumber(){
      return this.$store.state[this.stateCurrentRow]["certificate_management_number"]
    },
    registrationDate(){
      return  utils.format_date(this.$store.state[this.stateCurrentRow]["registration_date"]);
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          utils.extend(fields.certificate_management_number,{ disabled: true , read_only:true}),
          utils.extend(fields.licensed_department, {}),
          utils.extend(fields.license_jurisdiction_team, {}),
          utils.extend(fields.jurisdiction_classification, {
            on_set_value:(data) =>{
              setTimeout(() => {
                bus.$emit("upd_license_jurisdiction_system",{val: data == "EUC・その他"})
              }, 100);
            }
          }),
          utils.extend(fields.license_jurisdiction_system, {
            listen_for: [
              {
                name: "upd_license_jurisdiction_system",
                mode: "disable_if_value",
                disable_if_value: false
              }
            ],
          }),
          utils.extend(fields.license_certificate_type, {
            disabled: false,
            required: true,
            field_style: " width: 75%;display: inline;" ,
            buttons: [
                 {
                  btn_style:"width:20%;margin-left:2px;padding-left: 1px;padding-right: 1px;float:right; margin-top: 2px;margin-bottom: 2px;background: #43c9de;border-color:#43c9de;",
                  type:"callback",
                  callback:(b)=>{
                    this.openFileModal()
                },
                  label:"PDF"
               }
             ]
          }),
          utils.extend(fields.certificate_individual_number, {}),
          utils.extend(fields.maker, {}),
        ],
        col2:[
          utils.extend(fields.applicant_name, {}),
          utils.extend(fields.management_person_name, {}),
          utils.extend(fields.comprehensive_contract, {}),
          utils.extend(fields.sales_company, {}),
        ],
        col3:[
          utils.extend(fields.downgrade, {}),
          utils.extend(fields.deadline_alert, {}),
          utils.extend(fields.expiration_date, {}),
          utils.extend(fields.maintenance_deadline, {}),
        ],
        col2b:[
          utils.extend(fields.remark, {}),
          utils.extend(fields.other_items_by_manufacturer, {}),
        ],
      }
    },
    loadBy(){
      return this.$route.meta.load_by;
    }
  },
  methods: {
    processFieldStyle(store_key_name,last_changed_fields){
      this.$store.state[store_key_name] = {};
      if(last_changed_fields && last_changed_fields != null && last_changed_fields.length > 0 ){
        last_changed_fields.forEach(f=>{
          if(this.$store.state[this.stateCurrentRow]["approval_status"] == "申請中" && this.allowdToShowProcessAprovalButton){
            this.$store.state[store_key_name][f] = ";color:red;"
          }
        });
      }
    },
    openFileModal(){
      bus.$emit("showFileModal",{fk_id:this.certificateSeqId});
    },
    processApproval(){
      var changes = {
        seq_id:this.aprovalId,
        update_time: moment(new Date()).format("YYYY/MM/DD HH:mm:ss"),
      }
      this.$ajax.post('/approval_history/prepare_to_approve/' + this.aprovalId, {changes}, (err, result) => {
          if(err){
            this.$notify({
              title: 'データの承認に失敗しました。', 
              text: err,
              type: 'error',
              duration: 10000
            });
          }else{
            return this.$router.push("/approval_history");
          }
        })
    },
    onBulkCertificateInformationAddCheckConfirm(mode){
      setTimeout(()=>{
        if(mode == "yes"){
          this.read_only = false;
          this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
          var list_seq_id = Vue.localStorage.get('bulk_edit_' + this.local_page_id);
          try {
            list_seq_id = JSON.parse(list_seq_id)
            this.saveBulk(this.api_name,list_seq_id.arr, {}, (err)=>{
            })
          } catch (error) {
            this.$notify({
              title: "予期しないエラーが発生し、登録が行えません",
              text:error,
              type: 'error',
              duration: 12000
            })
          }
        }
      },100)
    },
    onConfirmExecuteProcess(){
      var list_seq_id = Vue.localStorage.get('bulk_edit_' + this.local_page_id);
      try {
        list_seq_id = JSON.parse(list_seq_id)
        var syubetu = constants.SYUBETU.CERTIFICATE
        bus.$emit("bulkCertificateApplicationConfimationModal",{
          list_seq_id:list_seq_id.arr,
          application_mode:"bulk_edit_certificate",
          title_prefix:""+syubetu+"(一括編集）",
          title_suffix:""+syubetu+"(一括編集）",
          process_import_url:'/' + this.api_name + '/bulk_to_approval_history/',
          on_finish_url_name:"close",
          ref_id:null,
        });
      } catch (error) {
        this.$notify({
          title: "適用する行の読込に失敗しました。",
          text:error,
          type: 'error',
          duration: 12000
        })
      }
    },
    onLocalSaveBulkCerInfeded(){
      console.log("onLocalSave")
      bus.$emit("confirmBulkCertificateInformationAddCheck",{
        message: "",
        title: "本当に登録してよろしいでしょうか。",
        yes_label: "完了",
        no_label: "キャンセル",
        yes_color:"primary",
        no_color:"",
        model_height:"50"
      });
    },
    onEdit(){
      mdebug("onEdit")
      setTimeout(() => {
        this.read_only = false;
      }, 300);
    },
    btnCancel() {
          this.cancelCurrentSelection(true);
    },
    approvalHistoryId:{
      get(){
        return this.approval_history_id;
      },
      set(v){
        this.approval_history_id = v;
      }
    },
    backToList(){
      Vue.localStorage.remove('bulk_edit_' + this.local_page_id);
        var device_back_to_list = window.sessionStorage.getItem("certificate_back_to_list")
      if((device_back_to_list||"").indexOf("/")==0){
        return this.$router.push(device_back_to_list);
      }
    },
    gotocertificate(){
      return this.$router.push({ name: "page_0040_certificate_information", params: {} });
    },
    selectCertificate(){
      this.showSubTable = true;
    }
  },
  mounted() {
    this.$store.state[this.stateCurrentEditing] = {};
    this.addHtmlClass(document.body,'blue_bg')
    this.local_page_id = this.$route.params.p_id;
    this.is_new = true;
    // Note, it is not editing a new record, but will emulate it, as the behaivour is the same.
    this.allFields.forEach(f =>{
      this.$store.state[this.stateCurrentRow][f.id] = "";
    })
    setTimeout(() => {
      this.$store.state[this.stateIsEditingNew] = true;
      this.read_only = false;
      this.is_new = true;
    }, 300);
  },
  beforeDestroy() {
    this.$store.state[this.stateCurrentEditing] = {};
    this.removeHtmlClass(document.body,'blue_bg')
  },
  beforeMount() {
  },
  
   }


</script>

<style scoped>

.bottom_tab  {
  width: 100%;
  margin-bottom: 20px;
}
.bottom_tab th {
  font-size: 12px;
}
.bottom_tab td input{
  border: solid #337ab7 1px;
  width: 98%;
  margin: 2px;
  border-radius: 5px;
  background-color: #e2ecf5;
  font-size: 12px;
  padding-left:4px;
}
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0040_certificate_information_detail_bulk_edit.vue?b57c73ce